export default {
    // LEAD_FORM is separate from the Universal Lead Form
    // This one is used in simple-home-lead only
    LEAD_FORM: 'lead-form',
    QUOTER: 'quoter',
    MTG_CROSS_SELL: 'mtg-cross-sell',
};

